import React, { createContext, useContext, useMemo } from "react";
import { getInitLayoutConfig } from "./LayoutConfig";
import { HtmlClassService } from "./HTMLClassService";
import { checkPathnameIncludes } from "../../_helpers/Pages";

const LAYOUT_CONFIG_KEY =
  process.env.REACT_APP_LAYOUT_CONFIG_KEY || "LayoutConfig";

function getConfig() {
  try {
    const ls = localStorage.getItem(LAYOUT_CONFIG_KEY);
    if (ls) return JSON.parse(ls);
  } catch (er) {
    // storage bloqueado ou JSON inválido: cai no layout padrão
    console.error(er);
  }

  const initLayoutConfig = getInitLayoutConfig();

  const PAGE_WITH_ASIDE_DEFAULT_MINIMIZED = ["/processual_query", "/page", "/gpt", "/space/whatsapp"];

  if (checkPathnameIncludes(PAGE_WITH_ASIDE_DEFAULT_MINIMIZED)) {
    initLayoutConfig.aside.self.minimize.default = true;
  }

  return initLayoutConfig;
}

// Side effect
export function setLayoutConfig(config) {
  try {
    localStorage.setItem(LAYOUT_CONFIG_KEY, JSON.stringify(config));
  } catch (er) {
    console.error(er);
  }
  window.location.reload();
}

const HtmlClassServiceContext = createContext();

/**
 *
 *
 * @export
 * @returns Layout context from 'localStorage'
 */
export function useHtmlClassService() {
  return useContext(HtmlClassServiceContext);
}

export function withHtmlClassService(Component) {
  class WithHtmlClassService extends React.Component {
    static displayName = `WithHtmlClassService(${Component.displayName ||
      Component.name})`;

    static contextType = HtmlClassServiceContext;

    render() {
      return <Component {...this.props} htmlClassService={this.context} />;
    }
  }

  return WithHtmlClassService;
}

export const HtmlClassServiceConsumer = HtmlClassServiceContext.Consumer;

export function MetronicLayoutProvider({ children }) {
  const lc = useMemo(getConfig, []);
  const hcs = useMemo(() => {
    const service = new HtmlClassService();

    service.setConfig(lc);

    return service;
  }, [lc]);

  return (
    <HtmlClassServiceContext.Provider value={hcs}>
      {children}
    </HtmlClassServiceContext.Provider>
  );
}
